import { DeleteOutlined, EditOutlined, QuestionCircleFilled } from '@ant-design/icons';
import { Button, Popconfirm, Popover, SelectProps, Space } from 'antd';
import { DetailKey } from 'procura-shared';
import React, { SyntheticEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DetailInput } from './Components';

type EditableProps = {
  value: string | number;
  detailKey?: DetailKey;
  render?: JSX.Element;
  onClick?: (e: SyntheticEvent) => void;
  onChange?: (value: string | number) => void;
  onSubmit?: (value: string | number) => void;
  onDelete?: () => void;
  editMode?: boolean | 'rename' | 'delete';
  options?: SelectProps<string>['options'];
};

export const Editable = ({
  value: defaultValue,
  detailKey = null,
  render,
  onChange,
  onSubmit,
  onClick,
  onDelete,
  options,
  editMode = false,
}: EditableProps) => {
  const { t } = useTranslation();
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState<string | number>(defaultValue);

  const deleteClickHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setEditing(false);
  };

  const deleteConfirmHandler = (e) => {
    deleteClickHandler(e);
    onDelete?.();
  };

  const editClickHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setEditing(true);
  };
  const changeHandler = (e: string | number) => {
    onChange?.(e);
    setValue(e);
  };
  const discardClickHandler = () => {
    setEditing(false);
    setValue(defaultValue);
  };

  const confirmHandler = () => {
    setEditing(false);
    onSubmit?.(value);
  };

  const renderEditing = () => (
    <Space direction="vertical" align="center">
      <DetailInput detailKey={detailKey} value={value} onChange={changeHandler} options={options} />
      <Space direction="horizontal">
        <Button type="default" onClick={discardClickHandler}>
          {t('cancel')}
        </Button>
        <Popconfirm title={t('submitChanges')} onConfirm={confirmHandler} okText={t('yes')} cancelText={t('no')}>
          <Button type="primary">{t('submit')}</Button>
        </Popconfirm>
      </Space>
    </Space>
  );

  return editMode !== false ? (
    <Popover placement="bottom" content={renderEditing()} visible={editing}>
      <Space>
        {render ? render : <span onClick={(e) => onClick?.(e)}>{defaultValue}</span>}
        {editMode !== 'delete' && <EditOutlined onClick={editClickHandler} />}
        {editMode !== 'rename' && (
          <Popconfirm
            title={t('deleteConfirm')}
            icon={<QuestionCircleFilled style={{ color: 'red' }} />}
            onConfirm={deleteConfirmHandler}
            okText={t('yes')}
            cancelText={t('no')}>
            <DeleteOutlined onClick={deleteClickHandler} />
          </Popconfirm>
        )}
      </Space>
    </Popover>
  ) : render ? (
    render
  ) : (
    <span onClick={(e) => onClick?.(e)}>{defaultValue}</span>
  );
};
